var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "remarks-list" }, [
    _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "subject" }, [
        _vm._v(_vm._s(_vm.$t("common.remarks"))),
      ]),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "items" },
        [
          _vm.isAsIs
            ? _c("li", [
                _c("div", { staticClass: "default-item" }, [
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.asIsRemarkTemplate.title) +
                        "\n            "
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.allowEdit,
                          expression: "allowEdit",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.remarksListAsIsRadio,
                          expression: "remarksListAsIsRadio",
                        },
                      ],
                      attrs: { type: "radio", value: "UNEDITABLE" },
                      domProps: {
                        checked: _vm._q(_vm.remarksListAsIsRadio, "UNEDITABLE"),
                      },
                      on: {
                        change: [
                          function ($event) {
                            _vm.remarksListAsIsRadio = "UNEDITABLE"
                          },
                          _vm.changeRemarksListAsIsRadio,
                        ],
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("pre", [_vm._v(_vm._s(_vm.asIsRemarkTemplate.content))]),
                  _vm._v(" "),
                  _vm.showAdditionalContent
                    ? _c("div", { staticClass: "addContentPoints" }, [
                        _vm.$te(
                          "terms." +
                            _vm.regionName +
                            ".hotb.content.takebackRemarksPointOne"
                        )
                          ? _c("table", [
                              _c("tr", [
                                _c("td", { staticStyle: { width: "25px" } }),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "50px" } }, [
                                  _vm._v("(i)"),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "terms." +
                                          _vm.regionName +
                                          ".hotb.content.takebackRemarksPointOne"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [_vm._v("(ii)")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "terms." +
                                          _vm.regionName +
                                          ".hotb.content.takebackRemarksPointTwo"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { attrs: { colspan: "3" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "terms." +
                                          _vm.regionName +
                                          ".hotb.content.takebackRemarksPointDescribe"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [_vm._v("(iii)")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "terms." +
                                          _vm.regionName +
                                          ".hotb.content.takebackRemarksPointThree"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "editable-item" },
                  [
                    _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.currentRemarksList.title) +
                          "\n            "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.allowEdit,
                            expression: "allowEdit",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.remarksListAsIsRadio,
                            expression: "remarksListAsIsRadio",
                          },
                        ],
                        attrs: { type: "radio", value: "EDITABLE" },
                        domProps: {
                          checked: _vm._q(_vm.remarksListAsIsRadio, "EDITABLE"),
                        },
                        on: {
                          change: [
                            function ($event) {
                              _vm.remarksListAsIsRadio = "EDITABLE"
                            },
                            _vm.changeRemarksListAsIsRadio,
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.allowEdit && !_vm.isEditing,
                            expression: "allowEdit && !isEditing",
                          },
                        ],
                        staticClass: "fa fa-pencil",
                        on: {
                          click: function ($event) {
                            _vm.isEditing = true
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("TextField", {
                      attrs: {
                        readonly: !_vm.isEditing,
                        afterBlur: _vm.afterBlur,
                        showColon: false,
                        value:
                          _vm.currentRemarksList.content ||
                          (_vm.isEditing ? "" : _vm.$t("remarkNA")),
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.defaultTemplate, function (item, index) {
            return _c("li", { key: index }, [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
              _vm._v(" "),
              _c("pre", { staticClass: "content" }, [
                _vm._v(_vm._s(item.content)),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm.isHandover
            ? _c("li", [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.documentsRemarks.title)),
                ]),
                _vm._v(" "),
                _c("pre", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.documentsRemarks.content)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.currentRemarksList.othersTitle)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "default-item-other" }, [
              _c("p", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("remarkNA")) +
                    "\n            "
                ),
                _c("input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.allowEdit,
                      expression: "allowEdit",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.otherRemarksRadio,
                      expression: "otherRemarksRadio",
                    },
                  ],
                  attrs: { type: "radio", value: "UNEDITABLE" },
                  domProps: {
                    checked: _vm._q(_vm.otherRemarksRadio, "UNEDITABLE"),
                  },
                  on: {
                    change: [
                      function ($event) {
                        _vm.otherRemarksRadio = "UNEDITABLE"
                      },
                      _vm.changeOtherRemarksRadio,
                    ],
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editable-item-other" },
              [
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("action.edit")) +
                      "\n            "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.allowEdit,
                        expression: "allowEdit",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.otherRemarksRadio,
                        expression: "otherRemarksRadio",
                      },
                    ],
                    attrs: { type: "radio", value: "EDITABLE" },
                    domProps: {
                      checked: _vm._q(_vm.otherRemarksRadio, "EDITABLE"),
                    },
                    on: {
                      change: [
                        function ($event) {
                          _vm.otherRemarksRadio = "EDITABLE"
                        },
                        _vm.changeOtherRemarksRadio,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.allowEdit && !_vm.isEditingOthers,
                        expression: "allowEdit && !isEditingOthers",
                      },
                    ],
                    staticClass: "fa fa-pencil",
                    on: {
                      click: function ($event) {
                        _vm.isEditingOthers = true
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    readonly: !_vm.isEditingOthers,
                    readonlyAsInput: !_vm.isEditingOthers,
                    afterBlur: function (event) {
                      return _vm.afterBlur(event, true)
                    },
                    placeholder: _vm.$t(
                      "terms." +
                        _vm.regionName +
                        ".hotb.content.otherRemarksHint"
                    ),
                    showColon: false,
                    value: _vm.currentRemarksList.othersContent,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.asIsDefinitions.title)),
            ]),
            _vm._v(" "),
            _c("pre", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.asIsDefinitions.content)),
            ]),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }